<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <v-card flat :disabled="loading">
        <v-overlay :value="isAutoSaving" z-index="9999" opacity="0.8" v-if="AutoSave">
          <div class="text-center d-flex flex-column align-center justify-center">
            <atom-spinner :animation-duration="1500" :size="100" class="mx-auto" color="#038118"/>
            <h3 class="mt-4 green--text">در حال ذخیره سازی خودکار...</h3>
            <p class="green--text mt-2">لطفاً چند لحظه صبر کنید</p>
          </div>
        </v-overlay>
        <v-row class="pa-2" no-gutters>
        
          <v-col cols="12" v-if="showGatewayPopup">
            <qr-edit-gateway
              v-model="showGatewayPopup"
              :sections="specialInfoSingle"
              :form-data="data"
              @edit-all="handleEditAll"
              @save="qrUpdate(false)"
              @cancel="onCancel"
            >
              <template v-slot:preview style="position: relative; min-height: 100%;">
                <v-card
                  v-if="loading"
                  class="d-flex align-center justify-center mt-10"
                  flat
                  min-height="50vh"
                >
                  <v-progress-circular indeterminate size="50" width="5" color="gray" />
                </v-card>
                <feedback-mobile-view
                  v-else
                  v-model="data"
                  class="sticky-preview"
                  :qr-svg-data-url="qrSvgDataUrl"
                />
              </template>
            </qr-edit-gateway>
          </v-col>

          <!-- فرم اصلی و استپر (زمانی که Gateway بسته است) -->
          <template v-if="!showGatewayPopup">
            <v-col
              class="pa-2 sticky-md text-center align-center"
              cols="12"
              md="4"
              style="top: 10px; height: fit-content"
            >
              <v-progress-circular
                v-if="loading"
                indeterminate
                color="gray"
              ></v-progress-circular>
              <feedback-mobile-view v-else v-model="data" :qr-svg-data-url="qrSvgDataUrl"/>
            </v-col>

            <v-col cols="12" md="8">
              <v-stepper v-model="e6" class="px-0 mx-0 qr-stepper" flat vertical>
                <v-stepper-step :complete="e6 > 1" class="px-0 px-md-4" step="1">
                  <div class="row justify-center">
                    <div class="col-md-12">
                      <p>وارد کردن اطلاعات کیوآر گالری بازخورد</p>
                    </div>
                    <div class="col-md-6 mt-0 pt-0">
                      <div class="rowinfo">
                        <v-text-field
                          v-model="res.title"
                          :disabled="e6 > 1"
                          append-icon="mdi-pen"
                          class="mt-0 pt-0 contentinfo"
                          clear-icon="mdi-close-circle-outline"
                          clearable
                          dense
                          label="نام  کیوآر گالری بازخورد شما"
                          outlined
                        />
                        <help-info
                          :element-name="`${serviceName}-${componentName}-res-title`"
                          :service-name="serviceName"
                          :help-data="helpData"
                          class="buttoninfo"
                          label="نام  گالری بازخورد"
                        />
                      </div>
                    </div>
                    <div class="col-md-6 mt-0 pt-0">
                      <div class="rowinfo">
                        <qr-address-field
                          id="qr-address"
                          v-model="res.identifier"
                          :domain-id="res.domain_id"
                          :error-messages="errors['identifier']"
                          append-icon="mdi-web"
                          class="mt-0 pt-0 contentinfo"
                          dense
                          outlined
                          persistent-hint
                          readonly
                          :key="$t('qrAddressUpdate.hints.allowedChars')"
                          :hint="$t('qrAddressUpdate.hints.allowedChars')"

                        />
                        <help-info
                          :element-name="`${serviceName}-${componentName}-res-identifier`"
                          :service-name="serviceName"
                          :help-data="helpData"
                          class="buttoninfo"
                          label="آدرس کیوآر"
                        />
                      </div>
                    </div>
                  </div>
                </v-stepper-step>
                <v-stepper-content class="pr-1 mx-0 mr-md-7 px-md-4" step="1">
                  <div class="mb-4">
                    <!-- سوییچ و آیکون راهنما -->
                    <div class="d-flex align-center">
                      <v-switch
                        v-model="AutoSave"
                        color="primary"
                        class="mt-0 pt-0 shrink"
                        hide-details
                        label="ذخیره خودکار"
                      ></v-switch>

                      <!-- آیکون راهنما با Tooltip (هاور برای دسکتاپ و تاچ برای موبایل) -->
                      <v-tooltip bottom max-width="320">
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            icon
                            x-small
                            class="mr-1"
                            v-bind="attrs"
                            v-on="on"
                            @click.stop
                          >
                            <v-icon small color="grey darken-1">
                              mdi-help-circle-outline
                            </v-icon>
                          </v-btn>
                        </template>
                        <span>
                          تغییرات هر بخش با بستن آن بخش به‌صورت خودکار ذخیره می‌شود. (تنظیمات کلی شامل ذخیره خودکار نیستند)
                        </span>
                      </v-tooltip>
                    </div>

                    <!-- متن کم‌رنگ و ظریف اختصاصی برای موبایل (زیر سوییچ) -->
                    <div
                      v-if="$vuetify.breakpoint.xsOnly"
                      class="text-caption grey--text text--darken-1 mt-1 pr-1"
                      style="line-height: 1.4"
                    >
                      تغییرات هر بخش با بستن آن بخش به‌صورت خودکار ذخیره می‌شود. (تنظیمات کلی شامل ذخیره خودکار نیستند)
                    </div>
                  </div>

                  <list-expansion
                    v-model="data"
                    :components="specialInfo"
                    :data="data"
                    flat
                    @save-required="AutoSave && qrUpdate(false)"

                  />

                  <div class="col-md-12">
                    <next-btn
                      :loading="loading"
                      style="background: #1b8d39"
                      @click="qrUpdate(true)"
                    />
                  </div>
                </v-stepper-content>
              </v-stepper>
            </v-col>
          </template>
        </v-row>
      </v-card>
    </template>
  </help-info-wrapper>
</template>

<script>
import QrMaker from "@/view/pages/qrland/components/qrMaker";
import SocialMobile from "@/view/pages/otherQrTypes/socialMedia/component/socialMobile";
import QrAddressField from "@/view/content/fragments/qrAddressField";
import ListExpansion from "@/view/content/fragments/listExpansion";
import NextBtn from "@/view/content/fragments/nextBtn";
import QrManagement from "@/view/pages/qrland/components/qrManage/qrManagement";
import PrevBtn from "@/view/content/fragments/prevBtn";
import { Bus } from "@/main";
import FeedbackMobileView from "./components/feedbackMobileView.vue";
import QrEditGateway from "../../qrland/components/QrEditGateway.vue";
import { mapActions } from "vuex";
import { AtomSpinner } from "epic-spinners";

export default {
  name: "editFeedback",

  components: {
    PrevBtn,
    QrManagement,
    NextBtn,
    ListExpansion,
    QrAddressField,
    SocialMobile,
    QrMaker,
    FeedbackMobileView,
    QrEditGateway, 
    AtomSpinner
  },

  data() {
    return {
      qrSvgDataUrl:'',
      isAutoSaving: false, 
      AutoSave:false,
      showGatewayPopup: this.$route?.query?.gateway === 'true', // استیت Gateway
      helpData: [],
      serviceName: "Qrland",
      componentName: "editVideo",
      e6: 1,
      qrShow: 1,
      svgMade: "",
      destinationUrl: "",
      createdId: null,
      dtUrl: null,
      shortId: null,
      showDialog: false,
      loading: false,
      errors: {},
      data: {},
      res: {},
      qrDesign: {},
      cons: { title: "دانلود کیوآر" },
    };
  },

  mounted() {
    this.fetchData();
    Bus.$on("socialMedias", (value) => {
      this.data.socialMedia = value;
    });
  },

  computed: {
    specialInfo() {
      return [
        {
          name: "baseInfo",
          value: "",
          title: this.$t("edit_bpage_special_info_special.information"),
          icon: "account-outline",
        },
        {
          name: "imageUploader",
          value: "",
          title: this.$t("edit_bpage_special_info_special.upload_logo"),
          icon: "image",
          model: "photo",
        },
        {
          name: "FeedBack",
          value: "",
          title: this.$t("edit_bpage_special_info_special.feedback"),
          subtitle: "",
          icon: "reply-outline",
          model: "FeedBack",
        },
        {
          name: "colorPallete",
          value: "",
          title: this.$t("edit_bpage_special_info_special.select_color"),
          subtitle: "",
          icon: "format-color-fill",
          model: "pallete",
        },
      ];
    },
    domainName() {
      return this.$route.params?.name?.replace('?gateway=true','');
    },
    qrId() {
      return this.$route.params?.id?.replace('?gateway=true','');
    },
specialInfoSingle() {
  const descriptionKeys = {
    baseInfo:
      "edit_feedback_special_single.base_info_description",

    imageUploader:
      "edit_feedback_special_single.image_uploader_description",

    FeedBack:
      "edit_feedback_special_single.feedback_description",

    colorPallete:
      "edit_feedback_special_single.color_palette_description",
  };

  return this.specialInfo.map((item) => {
    const descriptionKey = descriptionKeys[item.name];

    return {
      ...item,
      description: descriptionKey
        ? this.$t(descriptionKey)
        : "",
    };
  });
},
  },

  methods: {
    ...mapActions("localstorage", ["setCreatedQrID"]),
    ...mapActions("local", ["updateQrId", "updateQrInfo"]),

    onCancel() {
      this.$router.push({ name: "qr.list" });
    },
    handleEditAll() {
      this.showGatewayPopup = false;
    },

    fetchData() {
      this.loading = true;

      this.$api
        .get(
          `/v1/testQr/find/${this.domainName}${
            !!this.qrId ? "/" + this.qrId : ""
          }`,
        )
        .then(({ data }) => {
          let info = data.data.data;
          this.data = info.data;
          this.res = data.data;
          this.updateQrInfo(this.res);
          this.updateQrInfo(data.data);
          this.updateQrId(data.data.id);
          this.setCreatedQrID(data.data.id);
          this.qrSvgDataUrl= data?.data?.img_url||''; 
        })
        .finally(() => (this.loading = false));
    },
    
    qrUpdate(final = false) {
      if (final || !this.AutoSave) {
        this.loading = true;
      } else {
        this.isAutoSaving = true;
      }
      const data = new URLSearchParams();
      data.append("type", "feedbackGallery");
      data.append("qrType", "dynamic");
      data.append("domain", this.res.domain.name);
      data.append("identifier", this.res.identifier);
      data.append("qr_id", this.res.qrId);

      data.append(
        "data",
        JSON.stringify({
          theme: "",
          data: this.data,
        }),
      );

      this.$api
        .put("/v1/testQr/update", data, {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        })
        .then(({ data }) => {
          if(final || !this.AutoSave)
          this.$toast.success("بازخورد شما با موفقیت ویرایش شد.");
          
          if (final) {
            this.$router.push({ name: "qr.list" });
          }
        })
        .catch(({ response }) =>
          console.log("error in get response: ", response),
        )
        .finally(() => {
          this.loading = false;
          this.isAutoSaving = false;
        });
    },
  },
};
</script>

<style scoped>
.sticky-preview {
  position: -webkit-sticky;
  position: sticky;
  top: 0px !important;
  align-self: flex-start;
  height: max-content;
  z-index: 10;
}
</style>
